import { RaisedButton } from 'material-ui';
import React from 'react';
import ErrorContainer from '../../form/ErrorContainer';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import LoadingSpinner from '../../LoadingSpinner';

export class StripePage extends React.Component {
  
  componentWillReceiveProps(newProps){
    const { items, location } = newProps
    const { onboarded } = location.query
    const item = items[0]
    if(item && onboarded){
      this.onConnectResult.bind(this)(item, Boolean(onboarded));
    }
  }
  async onConnectResult(item, stripe_account_onboarded){
    await item._networkLayer.patchJSON('/backoffice/payments/stripe/connected-account', {
      stripe_account_onboarded
    })
    location.href = location.pathname
  }
  async onConnect(){
    const { items } = this.props;
    const item = items[0]

    const result = await item._networkLayer.postJson('/backoffice/payments/stripe/connected-account', {
      webapp_return_url: `${location.href}?onboarded=true`,
      webapp_refresh_url: `${location.href}?onboarded=false`
    })
    if(result.stripe_redirect_url){
      location.href = result.stripe_redirect_url
    }
  }

  render() {
    const { label, loadingItem, title, items, disabled, location } = this.props;
    const { onboarded } = location.query
    const item = onboarded ? null : items[0]
    const wrapStyle = { flex: 1, display: 'flex', maxWidth: '300px', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 100px)', flexDirection: 'column', marginLeft: 'auto', marginRight: 'auto' }
    const divStyle = {display: 'flex', marginBottom: '16px'}
    const spanStyle = {width: '150px', display: 'inline-block'}
    const itemOnboarded = item ? item.stripe_account_onboarded : false
    return (
      <ErrorContainer label={label} {...this.props}>
         <LoggedAppBar title={title} isStatic/>
         <LoadingSpinner show={ loadingItem }>
          <div style={wrapStyle}>
            { (!onboarded && item) ? <h2>Stripe account:</h2> : <h2>Wait to connect...</h2> }
            <br/>
              { item ? <div style={divStyle}><span style={spanStyle}>Connected: </span>{ item.stripe_account_onboarded ? 'YES' : 'NO' }</div> : null }
              { item ? <div style={divStyle}><span style={spanStyle}>Activated: </span>{ item.stripe_account_ready ? 'YES' : 'NO'}</div> : null }
              <br/>
              { itemOnboarded
                  ? <a href="https://dashboard.stripe.com/" target="_blank"><RaisedButton labelColor='white' secondary={false} type="submit" primary={true}><span style={{paddingLeft: '24px', paddingRight: '24px', color: 'white'}} >Stripe Dashboard</span></RaisedButton></a>
                  : item ? <RaisedButton disabled={disabled} onClick={this.onConnect.bind(this)} labelColor='white' secondary={false} type="submit" primary={true}><span style={{
                    paddingLeft: '24px', paddingRight: '24px', color: 'white'
                  }} >Connect to Stripe</span></RaisedButton> : null }
          </div>
         </LoadingSpinner>
      </ErrorContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Shop/StripePage/StripePage.jsx